export * from './customertyresearch.component';



// WEBPACK FOOTER //
// ./src/app/landingpages/customertyresearch/index.ts